@if (itemsLength() === 0) {
  <rp-table-placeholder [title]="titlePlaceholder() | translate" [subtitle]="subtitlePlaceholder() | translate">
    <ng-content select="[underPlaceholder]" />
  </rp-table-placeholder>
}
<div class="table" [hidden]="itemsLength() === 0">
  <mat-table class="table__mat-table" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
    @for (columnGroup of columnGroups() | keyvalue; track columnGroup) {
      @if (columnGroup.value.isShown) {
        <ng-container [matColumnDef]="columnGroup.key">
          <mat-header-cell
            class="table__header-group"
            *matHeaderCellDef
            [ngClass]="columnGroup.value.isBgTransparent ? 'table__header-group_transparent' : null"
            [style]="{
              'min-width': columnGroup.value.width + 'px',
            }"
          >
            <span class="table__header-group_text">{{ columnGroup.value.label | translate }}</span>
          </mat-header-cell>
        </ng-container>
      }
    }

    @for (column of columns(); track column; let i = $index) {
      @if (!column.hidden || !column.hidden()) {
        <ng-container [matColumnDef]="column.columnDef">
          @if (column.isSelect) {
            <mat-header-cell
              #headerCell
              class="table__header"
              *matHeaderCellDef
              [style]="{
                'min-width': column.width,
                'max-width': column.maxWidth,
                'justify-content': column.align,
                padding: column.padding,
              }"
            >
              <rp-table-checkbox
                [checked]="selection().hasValue() && isAllSelected()"
                [indeterminate]="selection().hasValue() && !isAllSelected()"
                (changed)="$event ? toggleAllRows() : null"
              />
            </mat-header-cell>
          } @else {
            <mat-header-cell
              #headerCell
              class="table__header"
              *matHeaderCellDef
              mat-sort-header
              [attr.group-by]="column.groupBy"
              [disabled]="!column.withSort"
              [style]="{
                'min-width': column.width,
                'max-width': column.maxWidth,
                'justify-content': column.align,
                padding: column.padding,
              }"
            >
              <span class="table__header_text">{{ column.header | translate }}</span>
            </mat-header-cell>
          }

          @if (column.actions) {
            <mat-cell
              id="mat-cell-{{ rowIndex + '-' + i }}"
              class="table__cell_actions"
              *matCellDef="let row; let rowIndex = index; dataSource: dataSource"
              [style]="{
                'min-width': column.width,
                'max-width': column.maxWidth,
                'justify-content': column.align,
                padding: column.padding,
              }"
            >
              @for (action of column.actions; track $index) {
                <rp-icon [iconName]="action" size="s" (iconClick)="onAction($event, action, row)" />
              }
            </mat-cell>
          } @else {
            <mat-cell
              id="mat-cell-{{ rowIndex + '-' + i }}"
              class="table__cell"
              *matCellDef="let row; let rowIndex = index; dataSource: dataSource"
              [style]="{
                'min-width': column.width,
                'max-width': column.maxWidth,
                'justify-content': column.align,
                padding: column.padding,
              }"
            >
              <div rpDynamicTitle class="table__cell_content" [style.text-align]="column.align">
                <ng-container [ngTemplateOutlet]="rowCellsTemplatesMap[column.columnDef + '-' + rowIndex]" />
              </div>
            </mat-cell>
          }
        </ng-container>
      }
    }

    @if (columnGroups()) {
      <ng-container *matHeaderRowDef="displayedColumnGroups()">
        <mat-header-row class="table__header-row"></mat-header-row>
      </ng-container>
    }

    <ng-container *matHeaderRowDef="displayedColumns()">
      <mat-header-row class="table__header-row"></mat-header-row>
    </ng-container>
    <mat-row
      class="table__row"
      *matRowDef="let row; let i = index; columns: displayedColumns()"
      [ngClass]="{
        hovered: isHoverEnabled(),
        total: i === dataSource.data.length - 1 && isShowTotal(),
      }"
      (click)="onRowClick(row)"
    />
  </mat-table>

  <mat-paginator
    #paginator
    [pageSize]="pageSize()"
    [pageIndex]="pageIndex()"
    [length]="itemsLength()"
    [showFirstLastButtons]="showFirstLastButtons()"
    [pageSizeOptions]="pageSizeOptions()"
    (page)="onPageChange($event)"
  />
</div>
